import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { Partners } from '@/models/partners';
import filterModel from '@/store/partners/filterModel';
import PartnersFilter from '@/store/partners/filterEntity';
import { Filter } from '@/types/filter/filter';
import { tabsNav } from './tabs';

@Module({ dynamic: true, store, name: Partners.moduleName, namespaced: true })
class PartnersModule extends PageBaseModule {
    allTabs = tabsNav;
    tabsNav = {};

    filter: Filter;

    constructor(module: PartnersModule) {
        super(module);

        this.tabsNav = this.allTabs;

        const page = new PageEntity();
        page.setModuleName(Partners.moduleName);
        page.setTitle(Partners.listTitle);
        page.setTitleAdd(Partners.createTitle);
        page.setTitleEdit(Partners.editTitle);
        page.values.actionPagination = 'partners/updatePage';
        page.values.actionPageAmountItems = 'partners/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Partners.moduleName}_edit`;
        this.pageSettings.routeParam = `${Partners.moduleName}Id`;

        const filter = new filterModel();
        this.filter = getModule(PartnersFilter);
        this.filter.setFilterName('PartnersFilter');
        this.filter.setTemplateClassName('template-lg directory-filters');
        this.filter.setFilterModel(filter.filterModel);
        this.filter.setFilterHandlers(filter.filterHandlers);
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(Partners.apiPrefix,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,
            );
            await this.context.dispatch('setList', result.table);
        } catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            await this.context.dispatch('updatePage', 1);
        }
    }
}

export default getModule(PartnersModule);
